<template>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div
        class="group my-4 rounded-lg border-iron-200 bg-white px-4 py-5 shadow-sm hover:shadow-md w-full border transition-all duration-200"
    >
        <div class="space-x-3 sm:flex items-start justify-between">
            <div class="gap-2 flex items-center">
                <div class="flex-shrink-0"></div>
                <div class="min-w-0 flex-1">
                    <p class="font-medium text-iron-900">
                        {{ availability.name }}
                    </p>
                    <div
                        v-for="(availabityRanges, dayName) in days"
                        :key="dayName"
                        class="py-2"
                    >
                        <p class="text-sm font-medium text-iron-500">
                            {{ dayName }}
                        </p>

                        <p
                            v-for="(range, i) of availabityRanges"
                            :key="i"
                            class="mt-1 text-sm text-iron-900 tracking-[-0.02rem]"
                        >
                            <span class="w-9 inline-block"
                                >{{ range.split("-")[0] }}
                            </span>
                            –
                            <span class="inline-block"
                                >{{ range.split("-")[1] }}
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="mt-3 sm:mt-0 flex flex-shrink-0 justify-start">
                <div class="rounded-md shadow-sm inline-flex">
                    <ManageAvailabilityModal
                        :availability-id="availability.id"
                        :availability-name="availability.name"
                        :days="editableDays"
                    >
                        <button
                            class="gap-2 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-iron-300 hover:bg-iron-50 relative -ml-px inline-flex items-center ring-1 ring-inset focus:z-10"
                        >
                            <Pencil :size="20" :stroke-width="1.5" />
                            <span class="sm:inline-block hidden">{{
                                $t("edit")
                            }}</span>
                        </button>
                    </ManageAvailabilityModal>

                    <button
                        class="ml-2 gap-2 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-iron-300 hover:bg-iron-50 relative inline-flex items-center ring-1 ring-inset focus:z-10"
                        @click="removeAvailability"
                    >
                        <Trash2 :size="20" :stroke-width="1.5" />
                        <span class="sm:inline-block hidden">{{
                            $t("remove")
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import ManageAvailabilityModal from "./ManageAvailabilityModal.vue";
import { Pencil, Trash2 } from "lucide-vue-next";
import { useEditableDays } from "../composables/useEditableDays";
import { AvailabilityDay } from "../types";

interface Props {
    availability: {
        id: number;
        name: string;
        readableAvailabilityDates: Array<string>;
        availability_dates: Array<any>;
    };
    days: AvailabilityDay;
}

const props = defineProps<Props>();

const { days: editableDays } = useEditableDays(props.availability);
const { show } = useConfirm();
const { t } = useI18n();

const removeAvailability = async () => {
    const result = await show({
        header: t("availability.availability_preview.are_you_sure"),
        message: t("availability.availability_preview.delete"),
        confirm: t("availability.availability_preview.remove"),
        cancel: t("cancel"),
    });

    if (result) {
        await router.delete(`availabilities/${props.availability.id}`);
    }
};
</script>

<style>
@import url("/node_modules/@zaptime/vue3/dist/style.css");
</style>
